/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFValidationError
 */
export interface CRSFValidationError {
    /**
     * 
     * @type {string}
     * @memberof CRSFValidationError
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFValidationError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFValidationError
     */
    title: string;
}

/**
 * Check if a given object implements the CRSFValidationError interface.
 */
export function instanceOfCRSFValidationError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function CRSFValidationErrorFromJSON(json: any): CRSFValidationError {
    return CRSFValidationErrorFromJSONTyped(json, false);
}

export function CRSFValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'status': json['status'],
        'title': json['title'],
    };
}

export function CRSFValidationErrorToJSON(value?: CRSFValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'status': value.status,
        'title': value.title,
    };
}

